import React, { useState, createContext } from "react"

export const QuizzContext = createContext({
    selectedQuizz: null,
    setSelectedQuizz: () => {},

    selectedKnowledge: 1,
    setSelectedKnowledge: () => {}
})

export default function QuizzProvider(props) {
    const { children } = props
    const [selectedQuizz, setSelectedQuizz] = useState(null)
    const [selectedKnowledge, setSelectedKnowledge] = useState(1)

    return (
        <QuizzContext.Provider
            value={{
                selectedQuizz,
                setSelectedQuizz,

                selectedKnowledge,
                setSelectedKnowledge
            }}
        >
            {children}
        </QuizzContext.Provider>
    )
}
